import React, { createContext, PureComponent } from 'react';
import { IGooglePayConfigurationContext } from '../types/GooglePayConfigurationContext';

interface IProps {
  children: JSX.Element;
}

const initialValue = {
  googlePayConfiguration: undefined,
};

export const GooglePayConfigurationContext = createContext<Partial<IGooglePayConfigurationContext>>(initialValue);

export class GooglePayConfigurationContextProvider extends PureComponent<
  IProps,
  Partial<IGooglePayConfigurationContext>
> {
  constructor(props) {
    super(props);
    this.state = {
      googlePayConfiguration: undefined,
    };
  }

  setGooglePayConfiguration = (googlePayConfiguration: google.payments.api.PaymentDataRequest) => {
    this.setState({ googlePayConfiguration });
  };

  render() {
    const { Provider } = GooglePayConfigurationContext;
    const { children } = this.props;
    return (
      <Provider
        value={{
          ...this.state,
          setGooglePayConfiguration: this.setGooglePayConfiguration,
        }}
      >
        {children}
      </Provider>
    );
  }
}
